import React, { useState, useRef } from 'react';
import './Login.css';
import { FaUser, FaLock } from 'react-icons/fa';
import { FiEye, FiEyeOff } from 'react-icons/fi';
import { FaApple } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import logo from '../../Logos/hvac-logo-new.jpg';
import googleicon from '../../Logos/googleicon.png';
import greenaire from '../../Logos/greenAire.png';
import axios from "axios";
import baseURL from '../ApiUrl/Apiurl';

export default function Login() {
  const [username, setUsername] = useState(""); 
  const [password, setPassword] = useState('');
  const [autoLogin, setAutoLogin] = useState(false);
  const [secureText, setSecureText] = useState(true);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false); // Added loading state
  const passwordRef = useRef();
  const navigate = useNavigate();

  const handleLogin = async (e) => {
  e.preventDefault();
  setError('');
  setLoading(true);

  try {
    let fcmToken = '';

    if (window.ReactNativeWebView && window.fcmToken) {
      fcmToken = window.fcmToken;
      console.log("Using Expo token:", fcmToken);
    }

    const response = await axios.post(`${baseURL}/user-login/`, {
      username,
      password,
      fcm_token: fcmToken,
    });

    const user = response.data.data;
    const sessionId = response.data.data.session_id; // ✅ NEW

    if (user.role === "Service Engineer") {
      // ✅ Store all necessary data
      localStorage.setItem("isLoggedIn", "true");
      localStorage.setItem("userRole", "service engineer");
      localStorage.setItem("userId", user.user_id);
      localStorage.setItem("userMobile", user.mobile_no);

      // ✅ Store session_id
      localStorage.setItem("session_id", sessionId);

      if (user.company_id) {
        localStorage.setItem("selectedCompany", user.company_id);
      }

      console.log("Session ID stored:", sessionId);

      // ✅ Send login message to Expo
      if (window.ReactNativeWebView) {
        window.ReactNativeWebView.postMessage(
          JSON.stringify({ type: 'login', userId: user.user_id })
        );
      }

      navigate("/dashboard", { 
        state: { 
          userMobile: user.mobile_no,
          userId: user.user_id,
          userData: user
        } 
      });

    } else {
      setError("User is not a Service Engineer");
    }

  } catch (err) {
    console.error("Login error:", err);
    setError(err.response?.data?.message || "Invalid mobile number or password");
  } finally {
    setLoading(false);
  }
};

  return (
    <div className="container">
      <div className="card">
        <div className="logoContainer">
          <img src={logo} alt="AIRO Logo" className="logo" />
        </div>
        <h2 className="welcome">WELCOME BACK!</h2>
        <p className="subtitle">Please login to your account</p>

        <form onSubmit={handleLogin}>
          <div className="inputWrapper">
            <FaUser className="icon" />
            <input
              type="text"
              placeholder="Enter Username"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === 'Enter') passwordRef.current.focus();
              }}
              disabled={loading} // Disable during loading
            />
          </div>

          <div className="inputWrapper">
            <FaLock className="icon" />
            <input
              type={secureText ? 'password' : 'text'}
              placeholder="Enter Password"
              value={password}
              ref={passwordRef}
              onChange={(e) => setPassword(e.target.value)}
              disabled={loading} // Disable during loading
            />
            <span 
              onClick={() => !loading && setSecureText(!secureText)} 
              className="eyeIcon"
              style={{ cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.6 : 1 }}
            >
              {secureText ? <FiEye /> : <FiEyeOff />}
            </span>
          </div>

          <div className="checkboxContainer">
            <label className="switchLabel">
              {/* <input
                type="checkbox"
                checked={autoLogin}
                onChange={(e) => !loading && setAutoLogin(e.target.checked)}
                disabled={loading}
              />
              <span className="label">Auto Login</span> */}
            </label>
            <span 
              className="forgot" 
              onClick={() => !loading && navigate('/forgot-password')}
              style={{ cursor: loading ? 'not-allowed' : 'pointer', opacity: loading ? 0.6 : 1 }}
            >
              Forgot Password? 
            </span>
          </div>

          {error && <p className="errorText">{error}</p>}

          <button 
            type="submit" 
            className={`loginButton shadow ${loading ? 'loading' : ''}`}
            disabled={loading}
          >
            {loading ? (
              <>
                <span className="spinner"></span>
                LOGGING IN...
              </>
            ) : (
              'LOGIN'
            )}
          </button>
          
          {/* <button type="button" className="socialButton" disabled={loading}>
            <img src={googleicon} alt="Google Icon" className="socialIcon" />
            <span className="socialText">Login with Google ID</span>
          </button>

          <button className="socialButton black" disabled={loading}>
            <FaApple className="socialIcon" color="#fff" />
            <span className="socialText white">Login with Apple ID</span>
          </button> */}
          
          {/* <p className="orText">Or</p>
          <p className="registerText">
            Don't have an account?{' '}
            <span 
              className="registerLink" 
              onClick={() => !loading && navigate('/signup')}
              style={{ cursor: loading ? 'not-allowed' : 'pointer' }}
            >
              Register
            </span>
          </p> */}

           <p className="registerText text-center mt-3">

                    First time login?{" "}

                    <span
                      className="registerLink"
                      style={{ cursor: "pointer", color: "#0096D6" }}
                      onClick={() => navigate("/signup")}
                    >
                      Set your security questions
                    </span>

                  </p>

          <img src={greenaire} alt="Green Aire" className="footerLogo" />
        </form>
      </div>
    </div>
  );
}